import { ExperienceCard } from './ExperienceCard';
import type { ExperienceCardData } from './types';

export { ExperienceCard, type ExperienceCardData };
export default ExperienceCard;
